export default "__VITE_ASSET__Cce6PdNf__"